import React from "react";

const Privacy: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <h1>Privacy Policy</h1>
        <p>Privacy Policy for League of Fabled Pursuits</p>

        <section className="legal-section">
          <h2>1. Information We Collect</h2>
          <p>
            We collect information you provide directly to us, such as when you
            create an account, participate in games, or contact us for support.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. How We Use Your Information</h2>
          <p>
            We use the information we collect to provide, maintain, and improve
            our services, to communicate with you, and to develop new features.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Information Sharing</h2>
          <p>
            We do not sell, trade, or otherwise transfer your personal
            information to third parties without your consent, except as
            described in this policy.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
